import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Tag } from 'primereact/tag';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { useGetLmsCreateRequestCommentsQuery } from '../../../../api';
import { formatDateOnly } from '../../../../utils/dateUtils';
import { TENDER_STATUS_SEVERITY, TENDER_STATUS_I18N_KEY, TENDER_REQUEST_TYPE } from '../utils/tenderRequestStatus';

// bkz. docs/LMS-IHALE--FE-Dokumani.txt §4.2 — ortak uç, requestType: 3 ile.
const TenderCommentHistoryDialog = ({ visible, requestId, onHide }) => {
    const { th } = useLanguage();
    const { data, isFetching } = useGetLmsCreateRequestCommentsQuery({ requestId, requestType: TENDER_REQUEST_TYPE }, { skip: !visible || requestId == null });
    const items = Array.isArray(data) ? data : [];

    return (
        <Dialog visible={visible} onHide={onHide} header={th('tenderRequest.history.title')} modal style={{ width: '40vw', minWidth: '380px' }}>
            {isFetching ? (
                <div className="flex justify-content-center align-items-center" style={{ minHeight: '120px' }}>
                    <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }} />
                </div>
            ) : items.length === 0 ? (
                <div className="text-color-secondary text-sm">{th('tenderRequest.history.emptyMessage')}</div>
            ) : (
                <div className="flex flex-column gap-3">
                    {items.map((item) => {
                        const i18nKey = TENDER_STATUS_I18N_KEY[item.status];
                        return (
                            <div key={item.id} className="surface-100 border-round p-3">
                                <div className="flex align-items-center justify-content-between mb-2 gap-2">
                                    <Tag value={i18nKey ? th(`tenderRequest.statuses.${i18nKey}`) : item.status} severity={TENDER_STATUS_SEVERITY[item.status] || 'secondary'} />
                                    <small className="text-color-secondary">{formatDateOnly(item.createdDate)}</small>
                                </div>
                                {item.comments && <div className="text-sm mb-1">{item.comments}</div>}
                                <small className="text-color-secondary">
                                    {th('tenderRequest.history.byLabel')}: {item.createdName}
                                </small>
                            </div>
                        );
                    })}
                </div>
            )}
        </Dialog>
    );
};

export default TenderCommentHistoryDialog;
